module.exports = __webpack_public_path__ + "static/media/write-fest-logo.5d8ea213.png";